module.exports = __webpack_public_path__ + "assets/img/73@3x.e4ed84ad.png";